import script from "./NumberType.vue?vue&type=script&lang=js"
export * from "./NumberType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__